import { BulletTabs } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const BulletTabsStyled = styled(BulletTabs)`
  padding: 4rem 10rem 8rem;
  min-height: 67rem;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
    min-height: auto;
  }
`;
